<script setup>
/**
 * "Test it", in the header of the pages that create the reason to press it.
 *
 * IT WAS A SIDEBAR ROW UNTIL REBUILD 2, and it was the wrong shape there twice over. It
 * is an ACTION, not a place — nobody goes to Test it, they go to try the thing they just
 * changed — and as a row it had zero inbound links from the three screens that create the
 * need. An owner rewrote the persona and then had to know, unprompted, that a row further
 * down the rail would let her check it.
 *
 * So it sits on Overview, Answers and Personality, and nowhere else. Not on Tasks: that
 * page has its own per-task try affordance and a second one in the header would be two
 * buttons claiming the same job. Not in the developer sub-group, which is not hers.
 *
 * The route is untouched — `waslo_test` still resolves, still has its own URL, and is
 * still bookmarkable. Only the nav row went.
 */
import { useRouter } from 'vue-router';

import Button from 'dashboard/components-next/button/Button.vue';

import { useWasloI18n } from '../i18n.js';
import { useWasloAccountId } from '../composables/useWasloAccountId.js';

const { t } = useWasloI18n();
const router = useRouter();
const accountId = useWasloAccountId();

const open = () =>
  router.push({
    name: 'waslo_test',
    params: { accountId: accountId.value },
  });
</script>

<template>
  <Button
    :label="t('WASLO.NAV.TEST')"
    icon="i-lucide-flask-conical"
    variant="faded"
    color="slate"
    size="sm"
    data-waslo-test-it
    @click="open"
  />
</template>
